import { type IntlShape } from 'react-intl'

import {
  OfferDiscountTypeEnumV2,
  type SellerPromotionV2,
} from '@redteclab/api/clients/bully'

import { i18nGetCurrencyForLocale, i18nGetCurrencySymbol } from '../../../i18n'

const getFormattedPromotionDiscountPercentage = (
  percentage: number,
  intl: IntlShape,
): string =>
  `${intl.formatNumber(percentage * 100, { maximumFractionDigits: 2 })}%`

const getCurrencySymbolFromLocale = (intl: IntlShape): string =>
  i18nGetCurrencySymbol(i18nGetCurrencyForLocale(intl.locale), intl)

export const getFormattedPromotionDiscountValueWithCurrency = (
  value: number,
  intl: IntlShape,
): string =>
  `${intl.formatNumber(value, {
    minimumFractionDigits: 0,
  })}${getCurrencySymbolFromLocale(intl)}`

/**
 * Based on the Designs and UX discussions, the currency symbols (explicitly either € or CHF)
 * need to be rendered before the discount amount (in the case of a total amount discount)
 * and the percent sign needs to come directly after the percentage (no extra space).
 */
export const getFormattedPromotionDiscountedAmountOrPercentage = (
  sellerPromotion: SellerPromotionV2,
  intl: IntlShape,
): string => {
  switch (sellerPromotion.discountType) {
    case OfferDiscountTypeEnumV2.TotalAmount: {
      return getFormattedPromotionDiscountValueWithCurrency(
        sellerPromotion.discountValue,
        intl,
      )
    }
    case OfferDiscountTypeEnumV2.TotalPercent: {
      return getFormattedPromotionDiscountPercentage(
        sellerPromotion.discountValue,
        intl,
      )
    }
    default: {
      return ''
    }
  }
}
